import FactorizationLogo from '~/assets/drill/factorization'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function Factorization({
  title,
  completed,
  path,
}: {
  title: string
  completed: boolean
  path: string
}): React.ReactElement {
  const gridMobile = 'row-start-13 row-end-15 col-start-1 col-end-3'
  const gridTablet = 'md:row-start-3 md:row-end-3 md:col-start-3 md:col-end-5'
  const gridDesktop = 'xl:row-start-2 xl:row-end-2 xl:col-start-2 xl:col-end-4'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={FactorizationLogo}
      imageClassNames="h-14"
      path={path}
      title={title}
    />
  )
}
